import { BaseInfoType, OptionsType } from './types';
// 辅助函数：验证 baseInfo 是否符合 baseInfoType
export const isBaseInfoType = (baseInfo: BaseInfoType):void => {
  // 如果传入不为对象 直接抛出异常
  if (typeof baseInfo !== 'object' || baseInfo === null) {
    throw new Error('基本参数信息类型错误');
  }

  // 获取调用方传入baseInfo时获取的key
  const baseInfoKeys = Object.keys(baseInfo) as (keyof BaseInfoType)[];

  // 获取baseInfoType的所有键 - 即需要匹配的所有键
  const matchKeys: (keyof BaseInfoType)[] = ['packageId', 'supplierCode', 'packageName', 'packageType', 'sellPrice', 'from'];

  // 如果存在baseInfo
  if (baseInfoKeys.length > 0) {
    // 遍历所需匹配的所有键
    matchKeys.forEach((matchKey) => {
      // 若该键不在baseInfoKeys中, 则抛出异常, 让调用方感知
      if (!baseInfoKeys.includes(matchKey)) {
        throw new Error(`${String(matchKey)}不存在`);
      }

      // 若该键对应的值为空, 则抛出异常, 让调用方感知
      if (!baseInfo[matchKey]) {
        throw new Error(`${String(matchKey)}值不能为空`);
      }
    });
  } else {
    // 不存在值抛出异常
    throw new Error('基本参数信息不能为空');
  }
};

// 辅助函数：验证 options 是否符合 optionsType
export const isOptionsType = (options?: OptionsType):void => {
  if (!options) return;

  if (typeof options !== 'object' || options === null) {
    throw new Error('额外参数信息类型错误');
  }

  // 获取调用方传入options时获取的key
  const optionsKeys = Object.keys(options) as (keyof OptionsType)[];

  // 获取options的所有键 - 即需要匹配的所有键
  const matchKeys: (keyof OptionsType)[] = ['buttonName', 'orderId', 'payWay', 'packageBuyStatus', 'action', 'capitalCode', 'productId', 'rateType'];

  // 检查额外参数信息存在的可选键类型正确
  matchKeys.forEach((matchKey) => {
    // 若有该键
    if (optionsKeys.includes(matchKey)) {
      // 该键对应的值为空, 则抛出异常, 让调用方感知
      if (!options[matchKey]) {
        throw new Error(`传入的${String(matchKey)}值不能为空`);
      }
    }
  });
};
